import { HIGHLIGHT_OVERLAY_RECTANGLE_CLASS } from 'constants';
import { UserContentCopiedText } from 'types';

/**
 * @method drawInlineUserContent
 */
const drawInlineUserContent = (
  frameDocument,
  userContentItem,
  inlineUserContent,
) => {
  const color = userContentItem.color ?? 'unsaved';
  const { highlightElement, spanStartElement, spanEndElement } =
    inlineUserContent;

  // Clear existing overlays
  highlightElement
    .querySelectorAll(`.${HIGHLIGHT_OVERLAY_RECTANGLE_CLASS}`)
    .forEach((e) => e.remove());

  // Get dimensions
  const range = frameDocument.createRange();
  range.setStart(spanStartElement, 0);
  range.setEnd(spanEndElement, 0);
  let rects, baseRect;

  try {
    rects = range.getClientRects();
    baseRect = range.getBoundingClientRect();
  } catch (e) {
    console.warn('Failed to place annotation.');
    return;
  }

  if (!rects || !rects.length) {
    return;
  }

  highlightElement.classList.remove(
    ...['yellow', 'green', 'red', 'blue', 'unsaved'],
  );
  highlightElement.classList.add(color);
  highlightElement.style.top = `${
    baseRect.top + frameDocument.body.scrollTop
  }px`;
  highlightElement.style.left = `${Math.ceil(
    baseRect.left + frameDocument.body.scrollLeft,
  )}px`;

  highlightElement.style.width = `${Math.ceil(baseRect.width) + 4}px`; // Add 4px to account for border
  highlightElement.style.height = `${baseRect.height}px`;

  // Configure each of the rectangle divs for the highlight
  for (let rect of rects) {
    const rectElement = document.createElement('span');
    rectElement.className = HIGHLIGHT_OVERLAY_RECTANGLE_CLASS;
    rectElement.style.width = `${Math.ceil(rect.width)}px`;
    rectElement.style.height = `${Math.ceil(rect.height - 4)}px`;
    rectElement.style.left = `${Math.ceil(rect.left - baseRect.left)}px`;
    rectElement.style.top = `${Math.ceil(rect.top - baseRect.top)}px`;

    highlightElement.appendChild(rectElement);

    // Copied text items need a custom dash pattern
    if (userContentItem instanceof UserContentCopiedText && rect.width !== 0) {
      const roundedWidth = Math.round(rect.width);
      let numDashesAndSpaces;

      // If width is odd use one more dash/space in order
      // to prevent dashes from creeping up left side of rect
      if (Math.floor(roundedWidth / 5) % 2) {
        numDashesAndSpaces = Math.floor(roundedWidth / 5);
      } else {
        numDashesAndSpaces = Math.floor(roundedWidth / 5) + 1;
      }

      let topDash = 0;
      let topSpace = roundedWidth; // topDash and topSpace values make stroke at top of rect nonexistant
      let rightDash = 0;
      let rightSpace = rect.height; // rightDash and rightSpace values make stroke at right of rect nonexistant
      let firstBottomDash = 0; // Make first bottom dash nonexistent so dashes appear to start from left to right
      let bottomSpacesAndDashes = Array(numDashesAndSpaces).fill(5).join(' '); // number of spaces and dashes rendered at the bottom of the rect

      rectElement.style.strokeDasharray = `${topDash} ${topSpace} ${rightDash} ${rightSpace} ${firstBottomDash} ${bottomSpacesAndDashes}`;
    }
  }
};

export default drawInlineUserContent;
